import React, {useEffect, useRef, useState} from "react";
import '../assets/css/main.css';
import "aos/dist/aos.css";
import AOS from 'aos'

function NavBar () {

    useEffect(() => {
        AOS.init();
        AOS.refresh();
    }, []);

    const [showMenu, setShowMenu] = useState(true);
    const pageList = useRef<HTMLUListElement>(null);

    function handleClick() {
        setShowMenu(!showMenu);
        if (pageList.current != null) {
            if (showMenu) {
                pageList.current.style.display = "block";
            } else {
                window.location.reload();
            }
        }
    }

    return (
        <>
            <header id="header" className="header d-flex align-items-center light-background sticky-top" >
                <div className="modal-shade" style={{display: showMenu ? "none" : "block"}}/>
                <div className="container-fluid position-relative d-flex align-items-center justify-content-between">
                    <a href="/" className="logo d-flex align-items-center me-auto me-xl-0" >
                        <span style={{fontFamily: 'Autography', fontSize: '30px'}}>Bravaldi</span>
                    </a>
                    <nav id="navmenu" className="navmenu">
                        <ul ref={pageList}>
                            <li><a href="/">Home</a></li>
                            <li><a href="/about">About</a></li>
                            <li><a href="/works">Works</a></li>
                            {/*}
                            <li><a href="/registration">Registration</a></li>
                            <li><a href="/contact">Contact</a></li>
                            */}
                        </ul>
                        <span onClick={handleClick}
                              className={showMenu ? "mobile-nav-toggle d-xl-none bi bi-list" : "mobile-nav-toggle d-xl-none bi bi-x"}
                              style={{color: showMenu ? 'var(--nav-color)': '#FFF'}}
                        ></span>
                    </nav>
                    <div className="header-social-links">
                        <a href="https://x.com/bravaldi" target="_blank" rel="noreferrer" className="twitter">
                            <i className="bi bi-twitter-x" />
                        </a>
                        <a href="https://www.facebook.com/profile.php?id=61572849707175" target="_blank" rel="noreferrer" className="facebook">
                            <i className="bi bi-facebook" />
                        </a>
                        <a href="https://bsky.app/profile/bravaldi" target="_blank" rel="noreferrer" className="instagram">
                            <i className="bi bi-bluesky" />
                        </a>
                        <a href="https://www.linkedin.com/in/josebravotejeda" target="_blank" rel="noreferrer" className="linkedin">
                            <i className="bi bi-linkedin" />
                        </a>
                    </div>
                </div>
            </header>
        </>
    )
}

export default NavBar;